import Main from "niteroi/packages/customer-services/controllers/Main.controller";

export default class Dashboard extends Main {
    public onInit(): void {
        super.onInit();
    }
}
